import React, {useState} from "react";

import {
  Box,
  Button,
  Checkbox,
  Column,
  Columns,
  Control,
  Field,
  Input,
  Select,
  Title,
} from "@allxsmith/bestax-bulma";

import useInput from "../../hooks/useInput";
import axios from "axios";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import {ToastContainer, toast} from "react-toastify";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh} from "../../state/selectors";
import CreatedModal from "./CreatedModal";
import PaymentTypePicker from "../Settings/PaymentTypes/PaymentTypePicker";
import TrackingOptionsPicker from "../Settings/TrackingCategory/TrackingOptionsPicker";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import TaxTypePicker from "../Settings/NominalCodes/TaxTypePicker";
import NominalCodePicker from "../Settings/NominalCodes/NominalCodePicker";


function NewTransaction({endpoint, type, paymentTypes, departments, departmentObjects, trackingOptions, trackingOptionObjects, nominalCodes, nominalObjects}) {
  const dataFresh = useSelector(getDataFresh);
  const [createdId, setCreatedId] = useState();
  const [createdModalOpen, setCreatedModalOpen] = useState(false);
  const dispatch = useDispatch();

  const accountOptions = [
    { name: "", value: "BLANK"},
    { name: "Hire", value: "hire_account_code"},
    { name: "Sale", value: "sale_account_code"},
    { name: "Workshop", value: "workshop_account_code"},
    { name: "Deposit", value: "deposit_account_code"},
    { name: "Loan", value: "loan_account_code"},
    { name: "Part", value: "part_account_code"},
    { name: "Court", value: "court_account_code"},
    { name: "Movement", value: "movement_account_code"}
  ];


  const paymentTypeObjects = paymentTypes ? paymentTypes.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {}) : {};
  const inout_mapping = {"OUT": "SP", "IN": "CC"};
  const type_mapping = {"OUT": "Outgoing", "IN": "Incoming"};

  const handleCustomerAccountChange = e => {
    setCustomerAccount(e.target.value);
  }

  const handleNominalCodeChange = e => {
    setNominalCode(nominalObjects[e.target.value])
  }


  const [isLoading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [contact, setContact] = useState({});
  const [, setTypeahead] = useState();

  const handleSearch = e => {
    setLoading(true);
    axios.get(`/api/contacts?contact_type=${inout_mapping[type]}&page_size=40&search=${e}`).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  };

  const handleContactSelect = contact => {
    setContact(contact[0]);
  };

  const handleTrackingOptionChange = e => {
    setTrackingOption(trackingOptionObjects[e.target.value]);
  }

  const [description, descriptionInput, setDescription] = useInput({
    type: "text",
    label: "Description"
  });
  const [paymentType, setPaymentType] = useState(type === "OUT"? paymentTypeObjects[Object.keys(paymentTypeObjects)[0]] : null);
  const [comments, commentsInput, setComments] = useInput({
    type: "text",
    label: "Comments"
  });
  const [invoiceNumber, invoiceNumberInput, setInvoiceNumber] = useInput({
    type: "text",
    label: "Invoice Number"
  });

  const [customerAccount, setCustomerAccount] = useState(accountOptions[0]['value']);
  const [nominalCode, setNominalCode] = useState({});
  const [trackingOption, setTrackingOption] = useState(trackingOptions.results[0]);
  const [ignoreFigure, setIgnoreFigure] = useState(false);

  const [department, setDepartment] = useState({id: 1, name: "Rentals Direct"})

  const [repeating, setRepeating] = useState(false);
  const [frequency, setFrequency] = useState("");
  const [amount, amountInput, setAmount] = useInput({
    type: "number",
    label: "Amount",
    currency: true
  });

  const [invoice_amount, invoiceAmountInput, setInvoiceAmount] = useInput({
    type: "number",
    label: "Invoice Amount",
    currency: true
  });
  const [invoice_vat, setInvoiceVat] = useState("INPUT2");
  const [invoice_date, invoiceDateInput, setInvoiceDate] = useInput({
    type: "date",
    label: "Invoice Date",
    initialValue: null
  });
  const [date, dateInput, setDate] = useInput({
    type: "date",
    label: "Date",
    initialValue: null
  });

  const handleSubmit = () => {
    if (!repeating && (!date || !description || !amount)) {
      toast.warning("You must specify an Invoice Date, Description and Amount!",{position: "top-right"})
    } else if (!description || !amount) {
      toast.warning("You must specify a Description and Amount!", {position: "top-right"})
    } else {
      const url = endpoint + "transactions";
      const conf = {
        method: "post",
        data: {
          description,
          customer_account: customerAccount,
          comments,
          type,
          amount,
          date: date || null,
          invoice_date: invoice_date || null,
          invoice_amount: invoice_amount || 0,
          invoice_vat: invoice_vat || 0,
          repeating: repeating,
          frequency: frequency,
          invoice_number: invoiceNumber,
          contact: contact,
          payment_type: paymentType,
          tracking_option: trackingOption || null,
          department: department,
          nominal_code: nominalCode,
          ignore_in_figures: ignoreFigure
        },
        url
      };

      return axios(conf).then((res) => {
        dispatch(createSetDataFreshAction(dataFresh + 1));
        setCreatedModalOpen(true);
        setCreatedId(res.data.id);
        setDescription("");
        setInvoiceDate("");
        setDate("");
        setAmount(0);
        setContact({});
        setInvoiceNumber("");
        setInvoiceAmount(0);
        setInvoiceVat(0);
        setComments("");
        setTrackingOption(null)
        setPaymentType(type === "OUT" ? paymentTypeObjects[Object.keys(paymentTypeObjects)[0]] : null)
        setDepartment({id: 1, name: "Rentals Direct"});
        setIgnoreFigure(false);
      }).catch(() => {
        toast.error("An error occured", {position: "top-right"});
      });

    }
  };

  const onDepartmentChange = e => {
    setDepartment(departmentObjects[e.target.value]);
  }

  return (
    <Box>
      <details>
        <summary><Title>{"Add" + ` ${type_mapping[type]}` + " Transaction"}</Title></summary>
      <Columns isMultiline>
        <Column>
          <Field className="has-addons">
            <Control>
              <label className="label">Repeating</label>
              <Button
                color={repeating ? "primary" : ""}
                onClick={() => setRepeating(true)}
              >
                Yes
              </Button>
              <Button
                color={!repeating ? "primary" : ""}
                onClick={() => {
                  setRepeating(false);
                  setFrequency("")
                }}
              >
                No
              </Button>
            </Control>
          </Field>
        </Column>
        {repeating &&
        <Column>
          <Field className="has-addons">
            <Control>
              <label className="label">Frequency</label>
              <Button
                color={frequency === "WEEKLY" ? "primary" : ""}
                onClick={() => setFrequency("WEEKLY")}
              >
                Weekly
              </Button>
              <Button
                color={frequency === "MONTHLY" ? "primary" : ""}
                onClick={() => setFrequency("MONTHLY")}
              >
                Monthly
              </Button>
            </Control>
          </Field>
        </Column>
        }
        {descriptionInput}
        <Column>
          <Field>
            <label className="label">Contact</label>
            <AsyncTypeahead
              id="typeahead"
              labelKey="display_name"
              minLength={2}
              name={"contact"}
              onSearch={handleSearch}
              onChange={handleContactSelect}
              placeholder={"Search Contact"}
              options={searchData}
              ref={typeahead => setTypeahead(typeahead)}
              className="typeahead"
              useCache={false}
              isLoading={isLoading}
              selected={
                contact && contact.id ? [contact] : []
              }
            />
          </Field>
        </Column>
        {type === "IN" &&
          <Column>
            <label className="label">Customer Account</label>
            <Select
              name={"customer_account"}
              disabled={false}
              value={customerAccount}
              onChange={handleCustomerAccountChange}
            >
              {accountOptions.map((option) => (
                  <option value={option.value}>{option['name']}</option>
              ))}
            </Select>
          </Column>
        }
        {commentsInput}
        <Column>
          <Field>
            <Control>
              <TrackingOptionsPicker
                inlineEdit={false}
                label={"Tracking Category"}
                name={"tracking_option"}
                options={trackingOptions}
                onChange={handleTrackingOptionChange}
                editable={true}
                blank={false}
                value={trackingOption}
                className={"no-small"}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <DepartmentSelector
            options={departments}
            name={"department"}
            inlineEdit={false}
            editable={true}
            classname={""}
            disabled={false}
            value={department}
            onChange={onDepartmentChange}
            blank={false}
            label={"Department"}
          />
        </Column>

      </Columns>
      <Columns isMultiline>
        {amountInput}
        <Column size={2}>
          <NominalCodePicker
            label={"Nominal Code"}
            name={"nominal_code"}
            value={nominalCode}
            options={nominalCodes}
            inlineEdit={false}
            disabled={false}
            editable={true}
            onChange={handleNominalCodeChange}
            blank={true}
            small={false}
          />
        </Column>

        {!repeating && dateInput}
        {type === "OUT" &&
            <Column>
              <label className="label">Payment Type</label>
              <PaymentTypePicker
                options={paymentTypes}
                inlineEdit={false}
                blank={false}
                disabled={false}
                onChange={(e) => setPaymentType(paymentTypeObjects[e.target.value])}
                value={paymentType}
              />
            </Column>
        }
      </Columns>
      {!repeating &&
      <Columns isMultiline>
        {invoiceAmountInput}
        <Column>
          <TaxTypePicker
            name={"invoice_vat"}
            label={"Invoice VAT"}
            value={invoice_vat}
            onChange={e => setInvoiceVat(e.target.value)}
          />
        </Column>
        <Column>
          <Field>
            <label className="label">Invoice Total</label>
            <Control>
              <Input
                value={(invoice_amount * (1 + (invoice_vat / 100))).toFixed(2)}
                type="number"
                readonly
                disabled
              />
            </Control>
          </Field>
        </Column>
        {invoiceNumberInput}
        {invoiceDateInput}
        <Column>
          <label className="label">Remove from Figures</label>
          <Checkbox
            checked={ignoreFigure}
            onChange={e => setIgnoreFigure(e.target.checked)}
            name={"ignore_in_figures"}
          />
        </Column>
      </Columns>
      }

      <Columns isMultiline>
        <Column>
          <Button onClick={handleSubmit} color={"success"} isFullWidth>
            Add
          </Button>
        </Column>
      </Columns>
      <CreatedModal open={createdModalOpen} id={createdId} setOpen={setCreatedModalOpen}/>
      </details>
    </Box>
  );
}

export default NewTransaction;
